import { render } from "./dropdown-search-menu.html?vue&type=template&id=b71f1b2a&scoped=true&ts=true"
import script from "./dropdown-search-menu.ts?vue&type=script&lang=ts"
export * from "./dropdown-search-menu.ts?vue&type=script&lang=ts"

import "./dropdown-search-menu.scss?vue&type=style&index=0&id=b71f1b2a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71f1b2a"]])

export default __exports__